import { render, staticRenderFns } from "./ntfDetail.vue?vue&type=template&id=057ae50c&scoped=true"
import script from "./ntfDetail.vue?vue&type=script&lang=js"
export * from "./ntfDetail.vue?vue&type=script&lang=js"
import style0 from "./ntfDetail.vue?vue&type=style&index=0&id=057ae50c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057ae50c",
  null
  
)

export default component.exports